import React, { useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import gsap from "gsap";
import IconImage from "assets/images/logo/cargills_GO.png"; // Replace with the actual path to your PNG icon
import Config, { ActiveClient } from "../../config";


const SplashScreenCargills = () => {
    const iconRef = useRef(null);
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        // Animation for the icon (make it larger)
        tl.fromTo(
            iconRef.current,
            { opacity: 0, scale: 0.5 },
            { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1, 0.7)" }
        );

        // Animation for the title
        tl.fromTo(
            titleRef.current,
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
            "-=0.5"
        );

        // Animation for the subtitle
        tl.fromTo(
            subtitleRef.current,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
            "-=0.5"
        );
    }, []);

    return (
        <div>
            <MetaTags>
                <title>Loading...</title>
            </MetaTags>
            <div style={styles.container}>
                {/* Icon */}
                <img
                    src={IconImage}
                    alt="Your Icon"
                    style={{ ...styles.icon, width: "200px", height: "100px" }}
                    ref={iconRef}
                />
                {/* Title */}
                <h1 ref={titleRef} style={{ ...styles.title, opacity: 0 }}>
                    {Config[ActiveClient].welcomeMessage}
                </h1>
                {/* Subtitle */}
                <p ref={subtitleRef} style={{ ...styles.subtitle, opacity: 0 }}>
                    Please wait while we log you in...
                </p>
                {/* You can add an image or any other content here */}
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f0f0",
    },
    title: {
        fontSize: "28px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    subtitle: {
        fontSize: "16px",
        color: "#555",
    },
    icon: {
        marginBottom: "16px", // Adjust the margin as needed
    },
};

export default SplashScreenCargills;
